// extracted by mini-css-extract-plugin
export default {"share":"Share_share__peTlS","share-body":"Share_share-body__UxOyS"};